<template>
    <div
        v-if="notifications.length > 0"
        ref="notificationCards">
        <div
            v-if="label"
            class="nav-title">
            {{ label }}
        </div>
        <div
            v-for="notification in notifications"
            :key="notification.id">
            <comment-notification-card
                v-if="isCommentNotification(notification)"
                v-bind="getCommonProps(notification)"
                @card-clicked="onCardClicked" />
            <request-notification-card
                v-else-if="getNotificationType(notification) === 'request'"
                v-bind="getCommonProps(notification)"
                :request-status="notification.displayHeadlineMessageTemplateData.requestStatus"
                :requested-permission="notification.displayHeadlineMessageTemplateData.requestAction"
                :requested-entity-type="notification.displayHeadlineMessageTemplateData.requestEntityType"
                :requested-entity-id="notification.displayHeadlineMessageTemplateData.requestEntityId"
                :request-id="notification.displayHeadlineMessageTemplateData.requestId"
                @manage-access="onManageAccess"
                @card-clicked="onCardClicked" />
        </div>
    </div>
</template>

<script>
import { ref } from 'vue';
import CommentNotificationCard from './comment-notification-card.vue';
import RequestNotificationCard from './request-notification-card.vue';

export default {
    name: 'NotificationList',
    components: {
        CommentNotificationCard,
        RequestNotificationCard,
    },
    props: {
        notifications: {
            type: Array,
            default: () => [],
        },
        label: {
            type: String,
            default: '',
        },
    },
    emits: ['cardClicked', 'manage-access'],
    setup () {
        const notificationCards = ref(null);

        return {
            notificationCards,
        };
    },
    methods: {
        isCommentNotification (notification) {
            return this.getNotificationType(notification) === 'comment' || this.getNotificationType(notification) === 'InAppCommentThread';
        },
        getNotificationType (notification) {
            if(notification.type) {
                return notification.type;
            }

            if (notification.displayHeadlineMessageTemplateData?.requestId) {
                return 'request';
            }

            if (notification.notificationSource === 'comment') {
                return 'comment';
            }

            return undefined;
        },
        getCommonProps (notification) {
            if(notification.type === 'InAppCommentThread') {
                return this.formatInAppComment(notification);
            }

            const user = {
                fullName: notification.actionUser.name,
                username: notification.actionUser.email,
            };

            return {
                id: notification.id,
                user,
                header: notification.displayHeadlineMessage,
                body: notification.displayBodyMessage,
                timeStamp: notification.formattedTimestamp,
                unread: notification.isUnread,
            };
        },
        formatInAppComment (notification) {
            return {
                ...notification,
                header: `New message from ${notification.user.fullName}`,
                body: notification.notification.comment,
                timeStamp: notification.formattedTimestamp,
                unread: !notification.read,
            };
        },
        onCardClicked (id) {
            this.$emit('cardClicked', id);
        },
        onManageAccess (data) {
            this.$emit('manage-access', data);
        },
    },
};
</script>

<style scoped lang="less">
@import '@/side-nav/nav.style.less';

.nav-title {
    margin-top: 20px;
    margin-bottom: 8px;
}
</style>
